import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6e58a6bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editable-field-wrap" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "editable-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: "editable-field editable-field--view",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startEdit && _ctx.startEdit(...args)))
    }, [
      _createVNode(_component_el_tooltip, {
        disabled: !_ctx.tooltip,
        content: _ctx.selfValue,
        placement: "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.selfValue || '--'), 1)
        ]),
        _: 1
      }, 8, ["disabled", "content"]),
      _createVNode(_component_CmSvgIcon, {
        name: "views/dashboard/_components/editable-field/_icons/edit",
        class: "editable-field__edit-icon",
        monochrome: ""
      })
    ], 512), [
      [_vShow, !_ctx.isEdit]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_input, {
        maxlength: "40",
        size: "mini",
        ref: "inputNode",
        modelValue: _ctx.selfValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selfValue) = $event)),
        onBlur: _ctx.handleBlur,
        onKeydown: _withKeys(_ctx.handleBlur, ["enter"])
      }, null, 8, ["modelValue", "onBlur", "onKeydown"]),
      _createElementVNode("span", {
        class: "cm-ui-ml5 cm-link",
        onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args)))
      }, "保存", 32)
    ], 512), [
      [_vShow, _ctx.isEdit]
    ])
  ]))
}